import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const VehicleTypeMaintenance = () => {
useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const canView  = hasPermission("Vehicle Type Maintenance", "view");


  useEffect(() => {
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/vehicle_typeMaster_api");
      setData(response.data.typeMaster);
      setFilteredData(response.data.typeMaster);
    } catch (error) {
      console.error("Error fetching typeMaster:", error);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);

  


  
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.fld_vehiclename || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
  


  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Vehicle Type Master Maintenance</h2>
          <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Vehicle Type"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Type</th>
                <th>Maintenance</th>
                <th>Sub Assembly</th>
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="6" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td>{item.fld_vehiclename}</td>
        <td>
         <Link to={`/vehicletype_maintenace_Entry/${item.fld_masid}`}> 
                Click
        </Link>
        </td>
        <td>

        <Link to={`/vehicletype_subassembly/${item.fld_masid}`}> 
    Click
        </Link>
        </td>
       
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};


export default VehicleTypeMaintenance;
